import moment from "moment-timezone";

const defaultFormat = "DD/MM/YYYY";

export const formatDate = (date: any = new Date(), format: string = defaultFormat, ignoreLocal = false, timeZone = "Europe/London") => {
  if (ignoreLocal) {
    return moment.tz(date, timeZone)
      .format(format);
  }

  return moment
    .utc(date)
    .local()
    .format(format);
};
